export default {
  investorId: (state) => state.investor.id,
  investor: (state) => state.investor,
  investorSettingsKey: (state) => state.investor.settingsKey,
  detailViewLoader: (state) => state.detailView.loading,
};
